import React, { Component } from 'react';
import Benefits from './Benefits.js';
import BenefitSearch from './BenefitSeacrh.js';
import axios from 'axios';
import { translate } from 'react-i18next';

let cancelToken;
let state;
let tokenSession;

class BenefitsContainer extends Component {

  getInitState = () => {
    return {
      city: "",
      cities: [],
      categoria: "",
      categorias: [],
      benefits: [],
      nivel_beneficio: "",
      errorr: "",
      errorQuery: "",
      benefitQuery: "",
      isSearching: false
    }
  }

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    if (this.state.benefits.length === 0) {
      this.reload();
    }
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  reload = () => {
    this.getBenefits({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      city_id: this.state.city ? this.state.city : "",
      category_id: this.state.categoria ? this.state.categoria : "",
      nivel_beneficio: this.state.nivel_beneficio ? this.state.nivel_beneficio : "",
      query: this.state.benefitQuery.trim()
    });

    this.getCitys({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

    this.getCategorias({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      city_id: this.state.city_id ? this.state.city_id : ""
    });

  }

  getBenefits = (params) => {
    this.props.post(
      "/listbenefits",
      params,
      (response) => this.didGetBenefits(response),
      (error) => this.handleErrorResponse(error),
      cancelToken
    );
  }

  getCitys = (params) => {
    this.props.post(
      "/getcitiesbenefits",
      params,
      (response) => this.didGetCity(response),
      (error) => this.handleErrorResponse(error),
      cancelToken
    );
  }

  getCategorias = (params) => {
    this.props.post(
      "/getcategories",
      params,
      (response) => this.didGetCategorias(response),
      (error) => this.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetBenefits = (response) => {
    const benefits = response.reduce((accum, ben) => {
      const month = new Date(ben.date)
      const today = new Date()
      // obtiene los objetos del mes actual contando con el año
      if (month.getMonth() === today.getMonth() && month.getFullYear() === today.getFullYear()) {
        accum.new.push(ben)
      } else {
        accum.old.push(ben)
      }
      return accum
    }, {
      new: [],
      old: []
    })
    // console.log(benefits)

    this.setState({ benefits })
  }

  didGetCity = (response) => {
    this.setState({ cities: response })
  }

  didGetCategorias = (response) => {
    this.setState({ categorias: response })
  }

  handleErrorResponse = (error) => {
    const { t } = this.props;
    alert(t('guest.benefits.NotFound'));
  }

  handleBenefitSearch = (event) => {
    this.setState({ benefitQuery: event.target.value });
  }

  handleCityChange = (event) => {
    this.setState({ city: event.target.value });
  }

  handleCategoriaChange = (event) => {
    this.setState({ categoria: event.target.value });
  }

  handleNivelBenfitChange = (event) => {  
    this.setState({ nivel_beneficio: event.target.value });
  }

  handleBenefitsSearch = (event) => {
    event.preventDefault();
    this.reload();
  }

  rebderBenefitSearch = () => {
    return (
      <BenefitSearch
        city={this.state.city}
        cities={this.state.cities}
        categoria={this.state.categoria}
        categorias={this.state.categorias}
        nivel_beneficio={this.state.nivel_beneficio}
        benefitQuery={this.state.benefitQuery}
        handleCityChange={this.handleCityChange}
        handleCategoriaChange={this.handleCategoriaChange}
        handleNivelBenfitChange={this.handleNivelBenfitChange}
        handleBenefitsSearch={this.handleBenefitsSearch}
        handleBenefitSearch={this.handleBenefitSearch}
      />
    );
  }

  renderBenefits = () => {
    // console.log(this.state.benefits)
    return (
      <Benefits events={this.state.benefits} />
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div className="content-benefits">
        <div className="container-benefits-title">
          <h2 className="page-header">{t('guest.benefits.heading')}</h2>
        </div>
        <div>
          <div className="content-benefits-search">
            {this.rebderBenefitSearch()}
          </div>
          <div className="content-benefits-content">
          {this.props.user.memberId ? 
          (
            <div id="benefits">
              {this.renderBenefits()}
            </div>
          ): (
            <h2 className="page-header">
              {t('guest.benefits.btn_helper')}
            </h2>
          ) }
          </div>
        </div>
      </div>
    );
  }

}

export default translate('common')(BenefitsContainer);


// WEBPACK FOOTER //
// ./src/dashboard/benefits/BenefitsContainer.js